import { Col, Row, Skeleton, Space } from 'antd';
import React from 'react';

import './ProjectHomePageSkeleton.scss';

export function ProjectHomePageSkeleton(): React.ReactElement {
  return (
    <Space direction="vertical" size={0} className="page-stack pf-page project-home-skeleton">
      {/* Header Skeleton */}
      <div className="skeleton-card">
        <Skeleton active paragraph={{ rows: 3 }} />
      </div>

      {/* Main Content Skeleton */}
      <Row gutter={16}>
        {/* Left Column Skeletons */}
        <Col xs={24} lg={18}>
          <Space direction="vertical" size="large" style={{ width: '100%', marginTop: '24px' }}>
            {/* Overview Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>

            {/* Timeline Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 3 }} />
            </div>

            {/* Health Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 5 }} />
            </div>

            {/* Hours Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>

            {/* Trends Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>

            {/* Weekly Status Updates Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 5 }} />
            </div>

            {/* Key Milestones Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          </Space>
        </Col>

        {/* Right Column Skeletons */}
        <Col xs={24} lg={6}>
          <Space direction="vertical" size="large" style={{ width: '100%', marginTop: '24px' }}>
            {/* Team Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>

            {/* Links Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 3 }} />
            </div>

            {/* Tech Stack Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>

            {/* Audit Card Skeleton */}
            <div className="skeleton-card">
              <Skeleton active paragraph={{ rows: 3 }} />
            </div>
          </Space>
        </Col>
      </Row>
    </Space>
  );
}
